import React from 'react';
import PropTypes from 'prop-types';


import Desplegable from '../../desplegable';
import DesplegableInformatica from "./desplegable_informatica";
import DesplegableIdiomas from "./desplegable_idiomas";


export const DesplegableFormacionAdicional = (props) => {

    return (
        <Desplegable
            Toogle="Formación adicional"
            Form={null}
            Text={
                <>
                    <DesplegableInformatica
                        state={props.state}
                        handleButtonShow={props.handleButtonShow}
                        setInformatica={props.setInformatica}
                        putInformatica={props.putInformatica}
                        deleteInformatica={props.deleteInformatica}
                        setAlert={props.setAlert}
                        ErrorHandling={props.ErrorHandling}
                    />
                    <DesplegableIdiomas
                        state={props.state}
                        handleButtonShow={props.handleButtonShow}
                        setIdioma={props.setIdioma}
                        putIdioma={props.putIdioma}
                        deleteIdioma={props.deleteIdioma}
                        setAlert={props.setAlert}
                        ErrorHandling={props.ErrorHandling}
                    />

                </>

            } />

    )
};

DesplegableFormacionAdicional.propTypes = {
    state: PropTypes.object.isRequired,
    handleButtonShow: PropTypes.func.isRequired,
    setInformatica: PropTypes.func.isRequired,
    putInformatica: PropTypes.func.isRequired,
    deleteInformatica: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    ErrorHandling: PropTypes.func.isRequired,
    setIdioma: PropTypes.func.isRequired,
    deleteIdioma: PropTypes.func.isRequired,
    putIdioma: PropTypes.func.isRequired,
}